export const commonLanguages = [
  { key: 'english', text: 'English', value: 'English' },
  {
    key: 'chinese-mandarin',
    text: 'Chinese (Mandarin)',
    value: 'Chinese (Mandarin)',
  },
  { key: 'french', text: 'French', value: 'French' },
  { key: 'spanish', text: 'Spanish', value: 'Spanish' },
  { key: 'portugese', text: 'Portugese', value: 'Portugese' },
  { key: 'japanese', text: 'Japanese', value: 'Japanese' },
  { key: 'korean', text: 'Korean', value: 'Korean' },
  { key: 'arabic', text: 'Arabic', value: 'Arabic' },
  { key: 'hindi', text: 'Hindi', value: 'Hindi' },
  { key: 'italian', text: 'Italian', value: 'Italian' },
  { key: 'russian', text: 'Russian', value: 'Russian' },
];
